import { createContext, useContext } from "react"

import { LocalizationContext, RecordContext } from "./index"

export const TLOContext = createContext()
TLOContext.displayName = "TLOContext"

export function TLOContextProvider({ subjectType, data, children }) {
  const currentLocalization = useContext(LocalizationContext)

  const viewCurrency =
    "currency_code" in data
      ? data.currency_code
      : currentLocalization.viewCurrency

  const defaultCurrency = viewCurrency

  const defaultAreaUnit =
    "area_unit_code" in data
      ? data.area_unit_code
      : currentLocalization.defaultAreaUnit

  const defaultLengthUnit =
    "length_unit_code" in data
      ? data.length_unit_code
      : currentLocalization.defaultLengthUnit

  return (
    <TLOContext.Provider
      value={{
        subjectType,
        data,
      }}
    >
      <LocalizationContext.Provider
        value={{
          ...currentLocalization,
          viewCurrency,
          defaultCurrency,
          defaultAreaUnit,
          defaultLengthUnit,
        }}
      >
        <RecordContext.Provider value={data}>{children}</RecordContext.Provider>
      </LocalizationContext.Provider>
    </TLOContext.Provider>
  )
}

export const useTLOContext = () => useContext(TLOContext)
